export enum EStoreEventType {
	Init,
	Synchro,
	NeedInfos,
	InitStartup
}